var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        scrollable: "",
        persistent: "",
        "max-width": "fit-content",
        transition: "dialog-transition"
      },
      model: {
        value: _vm.fileOpenerFallback.visible,
        callback: function($$v) {
          _vm.$set(_vm.fileOpenerFallback, "visible", $$v)
        },
        expression: "fileOpenerFallback.visible"
      }
    },
    [
      _c(
        "v-card",
        { attrs: { color: "background" } },
        [
          _c(
            "v-card-title",
            { staticClass: "background darken-1 py-1 pr-0" },
            [
              _c("span", { staticClass: "headline primary--text" }, [
                _vm._v("\n\t\t\t\tFileOpener\n\t\t\t")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", icon: "", color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pb-0 text-xs-center" },
            [
              _vm.winpath
                ? _c("div", { staticClass: "subheading" }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(_vm.winpath) + "\n\t\t\t")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fileOpenerFallback.message
                ? _c("div", { staticClass: "subheading error--text" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.fileOpenerFallback.message) +
                        "\n\t\t\t"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.fileOpenerFallback.status === "loading"
                ? _c("v-progress-linear", {
                    attrs: { height: "5", color: "primary", indeterminate: "" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.fileOpenerFallback.status !== "loading"
                ? _c("v-divider")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.fileOpenerFallback.status !== "loading"
            ? _c(
                "v-card-actions",
                { staticClass: "pt-0" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "Filesystem",
                          query: { path: _vm.winpath }
                        },
                        target: "_blank"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "text-none mr-5",
                          attrs: { color: "primary color--text" }
                        },
                        [
                          _c("v-icon", { staticClass: "mr-2" }, [
                            _vm._v("folder")
                          ]),
                          _vm._v("\n\t\t\t\t\tExplorer\n\t\t\t\t")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87a5e680", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87a5e680","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/file_opener_fallback.vue
// module id = null
// module chunks = 